import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganization } from '../organizations/selectors';
import { postCustomerSpaceRequest } from './data';
import { errorReceiveCustomerSpaceRequest, failedReceiveCustomerSpaceRequest, receiveCustomerSpaceRequest } from './slice';
export function* requestCustomerSpaceRequest(action) {
    try {
        const { siteInformation, emailAddress, rackVolume, powerNeeds, requirements } = action.payload;
        const { slug: organization } = yield select(getOrganization);
        const response = yield call(postCustomerSpaceRequest, siteInformation, organization, emailAddress, rackVolume, powerNeeds, requirements);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveCustomerSpaceRequest());
            yield put(appDanger(`${t('ERROR_REQUEST_CUSTOMER_SPACE', {
                ns: 'Common'
            })}: ${siteInformation}`));
        }
        else if (data) {
            yield put(receiveCustomerSpaceRequest());
            yield put(appSuccess(`${t('SUCCESS_REQUEST_CUSTOMER_SPACE', {
                ns: 'Common'
            })}: ${siteInformation}.`));
        }
        else {
            throw new Error(t('FAILED_REQUEST_CUSTOMER_SPACE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveCustomerSpaceRequest());
    }
}
export function* watchRequestCustomerSpaceRequest() {
    yield takeLatest('customerSpaceRequest/requestCustomerSpaceRequest', requestCustomerSpaceRequest);
}
